import { CardInterface } from '@modules/card/interfaces/card.interface';
import { CardModel } from '@modules/card/models/card.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export interface Equal3SectioInterface {
  headline?: string;
  anchor?: string;
  teasers: CardInterface[];
}

export class Equal3SectionModel implements Section {
  public type = SectionType.EQUAL_3;
  public teasers: CardModel[];
  public headline?: string;
  public anchor?: string;

  constructor(data: Equal3SectioInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.teasers = data.teasers.map((item) => new CardModel(item));
  }
}
